import { FetchResult, gql } from 'apollo-boost';
import { IUser } from '../../models/user';
import { MultiError } from '../../types/multi-error';
import { graphqlClient } from '../graphql-client';

const MUTATION = gql`
    mutation UserConfigRemoveCharacter($characterUid: String!){
        user_config_remove_character (characterUid: $characterUid) {
            success,
            user {
                uid,
                characters {
                    uid
                },
            },
        }
    }
`;

export interface IResultRemoveCharacter {
    success: boolean;
    user: IUser;
}

export async function removeCharacterFromUser(characterUid: string): Promise<IUser> {
    const result: FetchResult<{ user_config_remove_character: IResultRemoveCharacter}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { characterUid },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_config_remove_character.user;
}
